import React, { Component } from "react";
import _ from "underscore";
import PropTypes from "prop-types";
import IconButton from "./icon-button";
import classNames from "classnames";

class WizardFrame extends Component {
  static propTypes = {
    /** Title of wizard at the top of component */
    title: PropTypes.string,
    /** Total number of steps, not zero-indexed */
    steps: PropTypes.number.isRequired,
    /** current steps, not zero-indexed */
    currentStep: PropTypes.number,
    hideDots: PropTypes.bool,
    handleCancel: PropTypes.func,
  };

  static defaultProps = {
    title: "",
    hideDots: false,
    handleCancel: _.noop,
  };

  renderDots = () =>
    Array.from({ length: this.props.steps }, (_i, step) => (
      <span key={step} className={classNames("et-wizard--dot", this.props.currentStep === step + 1 ? "active" : "")} />
    ));

  render() {
    return (
      <div className="et-wizard">
        <div className="et-wizard--header">
          <div className="et-wizard--header-column">
            <div className="et-wizard--title">{this.props.title}</div>
            {this.props.hideDots ? null : <div className="et-wizard--dots">{this.renderDots()}</div>}
          </div>
          <div className="et-wizard--header-column">
            <IconButton
              title="close modal"
              className="et-wizard--header-close"
              icon="close"
              size={1}
              onClick={this.props.handleCancel}
            />
          </div>
        </div>
        {this.props.children}
      </div>
    );
  }
}

export default WizardFrame;
